import React from 'react';

/**
 * DashboardSkeleton
 *
 * Full dashboard skeleton shown while workspace dashboard data loads.
 */
export const DashboardSkeleton: React.FC = () => {
  return (
    <div className="animate-fade-in">
      {/* Greeting skeleton */}
      <div className="mb-6">
        <div className="h-7 w-72 bg-dark-200 dark:bg-dark-700 rounded animate-pulse mb-2" />
        <div className="h-4 w-96 bg-dark-200 dark:bg-dark-700 rounded animate-pulse" />
      </div>

      {/* Stats row skeleton */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="rounded-lg border border-dark-200 dark:border-dark-700 bg-white dark:bg-dark-800 p-5 shadow-card"
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-lg bg-dark-200 dark:bg-dark-700 animate-pulse" />
              <div className="flex-1">
                <div className="h-8 w-16 bg-dark-200 dark:bg-dark-700 rounded animate-pulse mb-2" />
                <div className="h-4 w-28 bg-dark-200 dark:bg-dark-700 rounded animate-pulse" />
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Activity and Quick Actions skeleton */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Activity feed skeleton */}
        <div className="lg:col-span-2 rounded-lg border border-dark-200 dark:border-dark-700 bg-white dark:bg-dark-800 shadow-card">
          <div className="px-5 py-4 border-b border-dark-200 dark:border-dark-700">
            <div className="h-5 w-32 bg-dark-200 dark:bg-dark-700 rounded animate-pulse" />
          </div>
          <div className="px-5 divide-y divide-dark-100 dark:divide-dark-700/50">
            {Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="flex gap-3 py-3">
                <div className="w-8 h-8 rounded-full bg-dark-200 dark:bg-dark-700 animate-pulse shrink-0" />
                <div className="flex-1">
                  <div className="h-4 w-3/4 bg-dark-200 dark:bg-dark-700 rounded animate-pulse mb-2" />
                  <div className="h-3 w-full bg-dark-200 dark:bg-dark-700 rounded animate-pulse mb-2" />
                  <div className="h-3 w-20 bg-dark-200 dark:bg-dark-700 rounded animate-pulse" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Quick actions skeleton */}
        <div className="rounded-lg border border-dark-200 dark:border-dark-700 bg-white dark:bg-dark-800 shadow-card">
          <div className="px-5 py-4 border-b border-dark-200 dark:border-dark-700">
            <div className="h-5 w-28 bg-dark-200 dark:bg-dark-700 rounded animate-pulse" />
          </div>
          <div className="p-5 space-y-3">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="rounded-lg border border-dark-200 dark:border-dark-700 p-4"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-dark-200 dark:bg-dark-700 animate-pulse" />
                  <div className="flex-1">
                    <div className="h-4 w-24 bg-dark-200 dark:bg-dark-700 rounded animate-pulse mb-1.5" />
                    <div className="h-3 w-36 bg-dark-200 dark:bg-dark-700 rounded animate-pulse" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

DashboardSkeleton.displayName = 'DashboardSkeleton';